import React, { useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.default,
    },
    form: {
      display: 'flex',
      alignItems: 'center',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    loadingSpinner: {
      marginLeft: '1em',
    },
    displayName: {
      marginLeft: '2.2em',
      minWidth: '200px',
      fontWeight: 600,
    },
  })
);

export default function MenuBar() {
  const classes = useStyles();
  let rommNameArray = window.location.search.match(/URLRoomName=(.*)&?/);
  let twilioToken = window.sessionStorage.getItem('twilioToken');

  const URLRoomName = rommNameArray ? rommNameArray[1] : window.sessionStorage.getItem('roomName');
  const { connect } = useVideoContext();


  useEffect(() => {
    window.onbeforeunload = (e: any) =>{
      window.sessionStorage.setItem('isConnected', "N");
    }
  });

  if(twilioToken && window.sessionStorage.getItem('isConnected') !== "Y"){
    connect(twilioToken, {});
    window.sessionStorage.setItem('isConnected', "Y");
  }


  return (
    <AppBar className={classes.container} position="static">
      <Toolbar className="menu-bar">
        <div className="room-info left-box">
          <h3 className="room-label">Room: </h3>
          <h3 className="room-value">{URLRoomName}</h3>
        </div>
        {/* )} */}
      </Toolbar>
    </AppBar>
  );
}
